// routes
import { Router } from "./routes/Router";
// theme
import ThemeProvider from "./theme";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import NotificationsForgroundListner from "./components/reusable-components/notifications/NotificationsForgroundListner";
import ToastContextProvider from "./context/ToasterContext";
import UserContextProvider from "./context/UserContext";
import TermsModalContextProvider from "./context/TermsModalContext";
import { useEffect } from "react";
import { getEventValuesCMSThunk } from "./store/events/eventThunk";
import { useAppDispatch } from "./hooks/storeHooks";
import { DeviceTypeEnum, NotificationPermissionEnum } from "./constants/enums";
import { requestForToken } from "./firebase";
import { saveDeviceTokenThunk } from "./store/user/userThunk";
import useUserInfo from "./hooks/reduxHelpersHooks/useUserInfo";
import { REDUX_REQUEST_STATUS } from "./types/commonTypes";
import { getLocalStorageItem, setLocalStorageItem } from "./helpers/localStorageHelpers";
import { FIREBASE_TOKEN_SYNC_STATUS } from "./constants/commonConstants";
import { setDeviceTokenGlobally } from "./store/user/userSlice";
import "./styles/global.scss";
import './assets/css/general-sans.css';

export default function App() {
  const dispatch = useAppDispatch();
  const { userDetails } = useUserInfo();

  const saveDeviceToken = async () => {
    try {
      const notificationPermission = await window?.Notification?.requestPermission();
      if (notificationPermission !== NotificationPermissionEnum.Granted) {
        console.warn("Notification permission not granted");
        return;
      }

      const deviceToken = await requestForToken(notificationPermission, true);

      if (!deviceToken) {
        console.warn("Device token not received");
        return;
      }

      const alreadySaved = getLocalStorageItem(FIREBASE_TOKEN_SYNC_STATUS);
      if (alreadySaved) {
        dispatch(setDeviceTokenGlobally(deviceToken));
        return;
      }

      const result = await dispatch(saveDeviceTokenThunk({ deviceToken: deviceToken, deviceType: DeviceTypeEnum.Web }));

      if (result.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
        setLocalStorageItem(FIREBASE_TOKEN_SYNC_STATUS, 'true');
        dispatch(setDeviceTokenGlobally(deviceToken));
      }
    } catch (error) {
      console.log("Error saving device token", error);
    }
  };

  useEffect(() => {
    if (userDetails?.id) saveDeviceToken();
  }, [userDetails]);

  useEffect(() => {
    dispatch(getEventValuesCMSThunk({}));
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <ToastContextProvider>
            <UserContextProvider>
              <TermsModalContextProvider>
                <NotificationsForgroundListner />
                <Router />
              </TermsModalContextProvider>
            </UserContextProvider>
          </ToastContextProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
